import type { AxiosRequestConfig } from 'axios'

/**
 * It takes a JSON string of data, parses it, and returns an empty array if the parse returns null.
 * Use it in the `transformResponse` field of your Axios requests in the `src/api/` folder.
 * @param data JSON string data.
 * @return Either an array of parsed data, or an empty array.
 * @example
 * export const getReviewsReplyMacro = (params?: AxiosRequestConfig['params']): Promise<IReplyReviewMacro[]> => {
 *  return request({
 *    params,
 *    transformResponse: toEmptyArrayIfNull,
 *    url: `${config.ADMIN_REVIEWS_API}/admin/reply_macro`,
 *  })
 * }
 */
export const toEmptyArrayIfNull = (data: string): Array<unknown> => {
  const parsedData = JSON.parse(data)
  return parsedData === null ? [] : parsedData
}

const defaultFiltersKeyName = (key: string): string => key

export const paramsSerializer = (
  params: AxiosRequestConfig['params'],
  filtersKeyName = defaultFiltersKeyName
): string => {
  const queryParams = Object.entries(Object.assign({}, params)).map(([key, value]) => {
    if (value === undefined) return ''

    if (Array.isArray(value)) {
      const reworkedValue = []
      for (let i = 0; i < value.length; i++) {
        if (typeof value[i] === 'number' || value[i].length > 0) {
          reworkedValue.push(`${filtersKeyName(key)}=${value[i]}`)
        }
      }
      return reworkedValue.join('&')
    }

    return `${filtersKeyName(key)}=${encodeURIComponent(value as string | number | boolean)}`
  })
  return queryParams.filter((param) => param.length).join('&')
}
